import { fr } from './fr';
import { en } from './en';
import { es } from './es';

export const translations = {
  fr,
  en,
  es
};

export const getTranslation = (language, key) => {
  // Split the key by dots to access nested properties
  const keys = key.split('.');
  
  // Start with the translations for the current language
  let result = translations[language];
  
  // Navigate through the nested properties
  for (const k of keys) {
    if (result && result[k] !== undefined) {
      result = result[k];
    } else {
      // If the key doesn't exist, return the key itself as fallback
      return key;
    }
  }
  
  return result;
};
